module.exports = __webpack_public_path__ + "static/media/viola.b92226fa.wav";